import { render } from "./MNavbar.vue?vue&type=template&id=cfc95738&scoped=true"
import script from "./MNavbar.vue?vue&type=script&lang=js"
export * from "./MNavbar.vue?vue&type=script&lang=js"

import "./MNavbar.vue?vue&type=style&index=0&id=cfc95738&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfc95738"]])

export default __exports__